import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-pink-hot/15 bg-noir-base/80 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-display italic text-3xl text-pink-hot">Layla</div>
          <div className="font-body text-[10px] tracking-[0.28em] text-rosegold/80 mt-1">LUXE · PINK · NOIR</div>
          <p className="mt-6 text-sm text-champagne/70 max-w-sm leading-relaxed">
            A private companion for the modern connoisseur. Discretion, elegance, and unforgettable chemistry.
          </p>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-pink-blush mb-5">Navigate</div>
          <ul className="space-y-3 text-sm text-champagne/80">
            <li><Link to="/about" className="hover:text-pink-hot">About</Link></li>
            <li><Link to="/rates" className="hover:text-pink-hot">Rates & Services</Link></li>
            <li><Link to="/gallery" className="hover:text-pink-hot">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-pink-hot">Contact & Booking</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.3em] uppercase text-pink-blush mb-5">Connect</div>
          <div className="flex gap-5 text-champagne/80">
            <a href="#" aria-label="Instagram" className="hover:text-pink-hot"><Instagram className="w-5 h-5" /></a>
            <a href="#" aria-label="Twitter" className="hover:text-pink-hot"><Twitter className="w-5 h-5" /></a>
            <a href="mailto:hello@luxe.com" aria-label="Email" className="hover:text-pink-hot"><Mail className="w-5 h-5" /></a>
          </div>
          <p className="mt-6 text-xs text-champagne/50 leading-relaxed">
            18+ only. By entering this site, you acknowledge you are of legal age in your jurisdiction.
          </p>
        </div>
      </div>
      <div className="border-t border-pink-hot/10 py-6 text-center text-xs tracking-[0.25em] uppercase text-champagne/40">
        © {new Date().getFullYear()} Layla — All rights reserved
      </div>
    </footer>
  );
}
